export default __webpack_public_path__ + "static/media/micOff.e9ff196e.svg";